import _toConsumableArray from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { getLocalDateFromTimezone, logger, isToday } from '@tradingblock/api';
import dayjs from 'dayjs';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import utc from 'dayjs/plugin/utc';
import _ from 'lodash';
import { DEFAULT_TRADINGSESSION } from './constants';
import { handleUpdates, subscribeOnStream, unsubscribeFromStream } from './streaming';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);
dayjs.extend(LocalizedFormat);
dayjs.extend(utc);
var AllSupportedResolutions = ['1', '5', '15', '30', '60', '1D'];
/** Stops infinite synchronous getBars re-entry when the API keeps returning []. */

var MAX_EMPTY_HISTORY_BACKFILLS = 40;
/** Do not request older ranges before this unix time (≈ Jan 1990). */

var MIN_HISTORY_UNIX = 631152000;
var lastBarsCache = new Map();
var symbolInfoCache = new Map();
var listenerGUIDCache = new Map();
export var TradingViewDataFeed =
/*#__PURE__*/
function () {
  function TradingViewDataFeed(api) {
    var _this = this;

    _classCallCheck(this, TradingViewDataFeed);

    /** Counts consecutive empty responses per symbol+resolution when backfilling with nextTime. */
    this.emptyBackfillCountByKey = new Map();
    /** Skips duplicate realtime payloads (same time/price/volume/delta) so chart volume is not applied twice. */

    this.lastChartTickFingerprintBySymbol = new Map();

    this.onReady = function (callback) {
      var config = {
        supports_marks: false,
        supports_timescale_marks: false,
        supports_time: true,
        supported_resolutions: AllSupportedResolutions
      };
      setTimeout(function () {
        return callback(config);
      });
    };

    this.searchSymbols =
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(userInput, exchange, symbolType, onResult) {
        var query, symbols, newSymbols, data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                query = userInput ? userInput.trim() : '';
                _context.next = 3;
                return _this.api.getSymbols({
                  query: query
                }, 200);

              case 3:
                symbols = _context.sent;
                newSymbols = symbols.filter(function (symbol) {
                  var isExchangeValid = exchange === '' || symbol.PrimaryExchange === exchange;
                  var isFullSymbolContainsInput = symbol.Symbol.indexOf(query.toUpperCase()) !== -1;
                  return isExchangeValid && isFullSymbolContainsInput;
                });
                data = newSymbols.map(function (symbol) {
                  return {
                    symbol: symbol.Symbol,
                    full_name: symbol.Symbol,
                    description: symbol.Description,
                    exchange: symbol.PrimaryExchange,
                    ticker: symbol.Symbol,
                    type: symbol.Type
                  };
                });
                onResult(data);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2, _x3, _x4) {
        return _ref.apply(this, arguments);
      };
    }();

    this.resolveSymbol = function (symbol, onResolve, onError) {
      var _$split = _.split(symbol, ':'),
          _$split2 = _slicedToArray(_$split, 2),
          exchange = _$split2[0],
          symbolName = _$split2[1]; // fallback to symbol passed in if no value after colon


      var symbolValue = symbolName || symbol;

      _this.api.getSymbols({
        query: symbolValue
      }, 1).then(function (symbolRes) {
        var match = _.find(symbolRes, function (s) {
          return s.Symbol && symbolValue && s.Symbol.trim().toLowerCase() === symbolValue.trim().toLowerCase();
        });

        var symbol = match || _.first(symbolRes);

        if (symbol) {
          _this.symbol = symbol.Symbol;
          var res = {
            format: 'price',
            name: symbol.Symbol,
            full_name: symbol.Symbol,
            description: symbol.Description,
            ticker: symbol.Symbol,
            exchange: symbol.PrimaryExchange,
            listed_exchange: symbol.PrimaryExchange,
            supported_resolutions: AllSupportedResolutions,
            type: symbol.Type,
            session: DEFAULT_TRADINGSESSION,
            minmov: 1,
            minmove2: 0,
            pricescale: 100,
            timezone: 'America/New_York',
            has_intraday: true,
            has_daily: true,
            has_weekly_and_monthly: false,
            currency_code: '$',
            data_status: 'streaming'
          };
          onResolve(res);
        } else {
          onError('couldnt find symbol');
        }
      });
    };

    this.getPeriodForResolution = function (res) {
      if (['1', '5', '15', '30'].includes(res)) {
        return "M".concat(res);
      } else if (res === '60') {
        return 'H1';
      } else {
        return 'Day';
      }
    };

    this.getBars =
    /*#__PURE__*/
    function () {
      var _ref2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(symbolInfo, resolution, periodParams, onResult, onError) {
        var rangeStartDate, rangeEndDate, firstDataRequest, period, starttime, endtime, maxDate, minDate, data, historyKey, nextEmptyCount, stopBackfill, bars, message, lower;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                rangeStartDate = periodParams.from, rangeEndDate = periodParams.to, firstDataRequest = periodParams.firstDataRequest; // Short-circuit if we're in a cooldown window due to previous 429.
                // Do not pass nextTime: TV would call getBars again immediately and recurse until stack overflow.

                if (!(_this.rateLimitResetAt && Date.now() < _this.rateLimitResetAt)) {
                  _context2.next = 4;
                  break;
                }

                onResult([], {
                  noData: true
                });
                return _context2.abrupt("return");

              case 4:
                period = _this.getPeriodForResolution(resolution);
                starttime = getLocalDateFromTimezone(dayjs.unix(rangeStartDate)).toDate();
                endtime = getLocalDateFromTimezone(dayjs.unix(rangeEndDate)).toDate();

                if (endtime.valueOf() > _this.api.marketClose.valueOf()) {
                  endtime = _this.api.marketClose;
                }

                maxDate = undefined;
                minDate = undefined;
                _context2.prev = 10;
                _context2.next = 13;
                return _this.api.getBars({
                  symbol: symbolInfo.name,
                  period: period,
                  starttime: starttime,
                  endtime: endtime
                });

              case 13:
                data = _context2.sent;
                historyKey = "".concat(symbolInfo.name, "~").concat(resolution); // nextTime triggers immediate older-range requests; empty+nextTime in a loop overflows the stack.

                if (!(data.length === 0)) {
                  _context2.next = 26;
                  break;
                }

                nextEmptyCount = (_this.emptyBackfillCountByKey.get(historyKey) || 0) + 1;
                stopBackfill = rangeStartDate <= MIN_HISTORY_UNIX || nextEmptyCount > MAX_EMPTY_HISTORY_BACKFILLS;

                if (!stopBackfill) {
                  _context2.next = 23;
                  break;
                }

                _this.emptyBackfillCountByKey.delete(historyKey);

                _this.log('getBars empty history; stopping backfill symbol=%s resolution=%s rangeStart=%s count=%s', symbolInfo.name, resolution, String(rangeStartDate), String(nextEmptyCount));

                onResult([], {
                  noData: true
                });
                return _context2.abrupt("return");

              case 23:
                _this.emptyBackfillCountByKey.set(historyKey, nextEmptyCount);

                onResult([], {
                  noData: true,
                  nextTime: rangeStartDate - 1209600
                });
                return _context2.abrupt("return");

              case 26:
                _this.emptyBackfillCountByKey.delete(historyKey);

                bars = [];
                data.forEach(function (bar) {
                  var bdate;
                  var dateString = bar.D.toString();

                  if (isToday(bar.D)) {
                    bdate = getLocalDateFromTimezone(dayjs(dateString));
                  } else {
                    bdate = getLocalDateFromTimezone(dayjs(bar.D));
                  }

                  maxDate = maxDate === undefined ? bdate : bdate > maxDate ? bdate : maxDate;
                  minDate = minDate === undefined || bdate < minDate ? bdate : minDate;
                  bars = [].concat(_toConsumableArray(bars), [{
                    time: bdate.utc().valueOf(),
                    low: bar.L,
                    high: bar.H,
                    open: bar.O,
                    close: bar.C,
                    volume: bar.V
                  }]);
                  _this.bars = bars;
                });

                if (firstDataRequest) {
                  // set lastBarsCache equal to the last bar in the response that is within the range
                  if (bars[bars.length - 1] !== undefined) {
                    lastBarsCache.set("".concat(symbolInfo.name, "~").concat(resolution), bars[bars.length - 1]);
                  }
                }

                onResult(bars, {
                  noData: false
                });
                _context2.next = 42;
                break;

              case 33:
                _context2.prev = 33;
                _context2.t0 = _context2["catch"](10);
                message = (_context2.t0 && _context2.t0.message ? String(_context2.t0.message) : '') || 'Unknown error'; // Treat 429 and CORS/network errors as cooldown conditions to stop backfill loops

                lower = message.toLowerCase();

                if (!(message.includes('RateLimited:429') || message.includes('RateLimited:cooldown') || lower.includes('cors') || lower.includes('preflight') || lower.includes('network') || lower.includes('xhr'))) {
                  _context2.next = 41;
                  break;
                }

                // Default cooldown 60s and suppress immediate retries
                _this.rateLimitResetAt = Date.now() + 60 * 1000;
                onResult([], {
                  noData: true
                });
                return _context2.abrupt("return");

              case 41:
                onError(message);

              case 42:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[10, 33]]);
      }));

      return function (_x5, _x6, _x7, _x8, _x9) {
        return _ref2.apply(this, arguments);
      };
    }();

    this.subscribeBars =
    /*#__PURE__*/
    function () {
      var _ref3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(symbolInfo, resolution, onTick, listenerGuid, onResetCacheNeededCallback) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this.subscribeBarsCallback = onTick;
                _this.resetCacheCallback = onResetCacheNeededCallback;
                _this.resolution = resolution;
                _this.listenToQuotes = true;
                symbolInfoCache.set("".concat(symbolInfo.name, "~").concat(resolution), symbolInfo);
                listenerGUIDCache.set("".concat(symbolInfo.name, "~").concat(resolution), listenerGuid);

                if (!_this.symbols.includes(symbolInfo.name)) {
                  _this.symbols.push(symbolInfo.name);
                }

                subscribeOnStream(symbolInfo, resolution, onTick, listenerGuid, onResetCacheNeededCallback, lastBarsCache.get("".concat(symbolInfo.name, "~").concat(resolution)));

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x10, _x11, _x12, _x13, _x14) {
        return _ref3.apply(this, arguments);
      };
    }();

    this.unsubscribeBars = function (listenerGuid) {
      _this.listenToQuotes = false;
      _this.bars = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = listenerGUIDCache.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref6 = _step.value;

          var _ref5 = _slicedToArray(_ref6, 2);

          var key = _ref5[0];
          var guid = _ref5[1];

          if (guid === listenerGuid) {
            var _ret = function () {
              // Extract symbol from key (format: "symbol~resolution")
              var symbol = key.split('~')[0];
              _this.symbols = _this.symbols.filter(function (s) {
                return s !== symbol;
              });

              _this.lastChartTickFingerprintBySymbol.delete(symbol);

              listenerGUIDCache.delete(key);
              symbolInfoCache.delete(key);
              lastBarsCache.delete(key);
              return "break";
            }();

            if (_ret === "break") break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      unsubscribeFromStream(listenerGuid);
    };

    this.isNextBar = function (latestExistingDate, nextDate, resolution) {
      return latestExistingDate.unix() < nextDate.unix();
    };

    this.resetCache = function () {
      if (_this.resetCacheCallback) {
        _this.resetCacheCallback();
      }
    };

    this.onQuoteChange =
    /*#__PURE__*/
    function () {
      var _ref7 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(quotes, isHeikinAshi,
      /** Prefer TradingView activeChart().resolution() when available — avoids cache misses during timeframe changes. */
      effectiveResolution) {
        var quotesArray;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(!quotes || typeof quotes !== 'object')) {
                  _context4.next = 3;
                  break;
                }

                console.warn('❌ Invalid quotes object received:', quotes);
                return _context4.abrupt("return");

              case 3:
                // Slots may be undefined (selector placeholders); only process defined rows. Empty is normal during resolution changes.
                quotesArray = Object.keys(quotes).map(function (key) {
                  return quotes[key];
                }).filter(function (q) {
                  return q != null && typeof q === 'object' && typeof q.Symbol === 'string';
                });

                if (!(quotesArray.length === 0)) {
                  _context4.next = 6;
                  break;
                }

                return _context4.abrupt("return");

              case 6:
                quotesArray.forEach(function (quote, index) {
                  // Enhanced validation for each quote
                  if (!quote) {
                    console.warn("\u274C Quote ".concat(index, " is null/undefined"), quote);
                    return;
                  }

                  if (!quote.Symbol) {
                    console.warn("\u274C Quote ".concat(index, " missing Symbol:"), quote);
                    return;
                  }

                  if (quote.LastTradePrice === undefined || quote.LastTradePrice === null) {
                    console.warn("\u274C Quote ".concat(index, " missing price:"), quote);
                    return;
                  }

                  if (!quote.ReceivedTime) {
                    console.warn("\u274C Quote ".concat(index, " missing ReceivedTime:"), quote);
                    return;
                  }

                  var matched = _this.matchQuoteToCaches(quote.Symbol, effectiveResolution);

                  if (!matched) {
                    if (_this.symbols.some(function (s) {
                      return s.toUpperCase() === quote.Symbol.trim().toUpperCase();
                    })) {
                      var effRes = effectiveResolution != null ? effectiveResolution : '(none)';
                      var feedRes = _this.resolution != null ? _this.resolution : '(none)';
                      var keyList = Array.from(symbolInfoCache.keys()).join(',');
                      console.warn('[DataFeed] onQuoteChange: no subscription cache for symbol=%s effectiveRes=%s this.resolution=%s cachedKeys=%s', quote.Symbol, effRes, feedRes, keyList);
                    }

                    return;
                  }

                  var symbolInfo = matched.symbolInfo,
                      listenerGuid = matched.listenerGuid,
                      cacheKey = matched.cacheKey;
                  var streamResolution = cacheKey.split('~')[1];
                  var tickFingerprint = "".concat(quote.ReceivedTime, "\x1F").concat(quote.LastTradePrice, "\x1F").concat(String(quote.Volume), "\x1F").concat(String(quote.LastTradeVolume));

                  var prevFp = _this.lastChartTickFingerprintBySymbol.get(quote.Symbol);

                  if (prevFp === tickFingerprint) {
                    return;
                  }

                  _this.lastChartTickFingerprintBySymbol.set(quote.Symbol, tickFingerprint);

                  try {
                    var bar = handleUpdates(symbolInfo, streamResolution, _this.subscribeBarsCallback, listenerGuid, _this.resetCacheCallback, quote, isHeikinAshi);

                    if (bar) {
                      lastBarsCache.set(cacheKey, bar);
                    }
                  } catch (error) {
                    console.error('❌ Error in handleUpdates for quote:', quote, 'Error:', error);
                  }
                });

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x15, _x16, _x17) {
        return _ref7.apply(this, arguments);
      };
    }();

    this.api = api;
    this.bars = [];
    this.listenToQuotes = false;
    this.log = logger('DataFeed');
    this.symbols = [];
  }
  /**
   * Match Redux quote.Symbol to TV cache keys (symbolInfo.name may differ by case).
   * `effectiveResolution` should be the chart's live resolution when available — `this.resolution` can lag
   * subscribeBars during rapid timeframe switches, causing silent misses.
   */


  _createClass(TradingViewDataFeed, [{
    key: "matchQuoteToCaches",
    value: function matchQuoteToCaches(quoteSymbol, effectiveResolution) {
      var attempts = _.uniq([effectiveResolution, this.resolution].filter(function (r) {
        return r != null && r !== '';
      }));

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = attempts[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var res = _step2.value;
          var hit = this.matchQuoteToCachesForResolution(quoteSymbol, res);

          if (hit) {
            return hit;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return this.matchQuoteToAnyCachedResolution(quoteSymbol);
    }
  }, {
    key: "matchQuoteToCachesForResolution",
    value: function matchQuoteToCachesForResolution(quoteSymbol, res) {
      var suffix = "~".concat(res);
      var directKey = "".concat(quoteSymbol).concat(suffix);

      if (symbolInfoCache.has(directKey) && listenerGUIDCache.has(directKey)) {
        return {
          symbolInfo: symbolInfoCache.get(directKey),
          listenerGuid: listenerGUIDCache.get(directKey),
          cacheKey: directKey
        };
      }

      var q = quoteSymbol.trim().toUpperCase();
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = symbolInfoCache.keys()[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var key = _step3.value;

          if (!key.endsWith(suffix)) {
            continue;
          }

          var name = key.split('~')[0];

          if (name && name.toUpperCase() === q) {
            return {
              symbolInfo: symbolInfoCache.get(key),
              listenerGuid: listenerGUIDCache.get(key),
              cacheKey: key
            };
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return null;
    }
    /** Last resort when subscribeBars resolution and UI disagree (race during timeframe change). */

  }, {
    key: "matchQuoteToAnyCachedResolution",
    value: function matchQuoteToAnyCachedResolution(quoteSymbol) {
      var q = quoteSymbol.trim().toUpperCase();
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = symbolInfoCache.keys()[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var key = _step4.value;

          var _key$split = key.split('~'),
              _key$split2 = _slicedToArray(_key$split, 1),
              name = _key$split2[0];

          if (!name || name.toUpperCase() !== q) {
            continue;
          }

          if (!listenerGUIDCache.has(key) || !symbolInfoCache.has(key)) {
            continue;
          }

          return {
            symbolInfo: symbolInfoCache.get(key),
            listenerGuid: listenerGUIDCache.get(key),
            cacheKey: key
          };
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return null;
    }
  }]);

  return TradingViewDataFeed;
}(); //   calculateHistoryDepth?(resolution: ResolutionString, resolutionBack: ResolutionBackValues, intervalBack: number): HistoryDepth | undefined;
// getMarks?(symbolInfo: LibrarySymbolInfo, from: number, to: number, onDataCallback: GetMarksCallback<Mark>, resolution: ResolutionString): void;
// getTimescaleMarks?(symbolInfo: LibrarySymbolInfo, from: number, to: number, onDataCallback: GetMarksCallback<TimescaleMark>, resolution: ResolutionString): void;

/**
 * This function is called if configuration flag supports_time is set to true when chart needs to know the server time.
 * The charting library expects callback to be called once.
 * The time is provided without milliseconds. Example: 1445324591. It is used to display Countdown on the price scale.
 */
// getServerTime?(callback: ServerTimeCallback): void;
// subscribeDepth?(symbolInfo: LibrarySymbolInfo, callback: DomeCallback): string;
// unsubscribeDepth?(subscriberUID: string): void;